import { useState } from "react";
import type { MorphemeGlyphTileWordFront } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.glyphs";

export type SortMode = "frequency" | "hsk";

export type HskLevel = 1 | 2 | 3 | 4 | 5 | 6 | 79;

/** How the HSK view orders words within the selected level. */
export type HskSortMode = "frequency" | "strokes" | "learning";

/** What each word tile shows on its front: written glyphs (default) or readings. */
export type WordTileFront = MorphemeGlyphTileWordFront;

export function useBrowseWordsPageContextValue() {
  const [sortMode, setSortMode] = useState<SortMode>("frequency");
  const [hskLevel, setHskLevel] = useState<HskLevel>(1);
  const [hskSortMode, setHskSortMode] = useState<HskSortMode>("learning");
  /**
   * Whether the HSK words grid includes one-glyph entries. Off by default — the character
   * curriculum already covers those forms, so the words list focuses on multi-character words.
   */
  const [showSingleCharacterWords, setShowSingleCharacterWords] = useState(false);
  const [wordTileFront, setWordTileFront] = useState<WordTileFront>("glyphs");

  return {
    hskLevel,
    hskSortMode,
    setHskLevel,
    setHskSortMode,
    setShowSingleCharacterWords,
    setSortMode,
    setWordTileFront,
    showSingleCharacterWords,
    sortMode,
    wordTileFront,
  };
}

export type BrowseWordsPageContextValue = ReturnType<typeof useBrowseWordsPageContextValue>;
